export type UserPermissionsMetadataForLensMetadataResponse = {
  user_is_admin: boolean;
  user_is_owner: boolean;
  user_lens_capabilities: LensCapability[];
}

export type LensCapability = {
  capability: UserEditCapability;
  is_allowed: boolean;
}

export enum UserEditCapability {
  WRITE = 'WRITE',
}
